"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabs = exports.Tabs = exports.Tab = void 0;

var _react = _interopRequireWildcard(require("react"));

var _flattenChildren = require("../../helpers/flattenChildren");

var _useUpdateEffect = require("../../utils/useUpdateEffect");

var _BaseTabs = require("../BaseTabs");

var _Clickable = require("../Clickable");

var _excluded = ["children", "initialTabIndex", "onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Tabs functionality */
var useTabs = function useTabs(_ref) {
  var children = _ref.children,
      _ref$initialTabIndex = _ref.initialTabIndex,
      initialTabIndex = _ref$initialTabIndex === void 0 ? 0 : _ref$initialTabIndex,
      onChange = _ref.onChange;
  var tabs = (0, _react.useMemo)(function () {
    return (0, _flattenChildren.flattenChildren)(children).map(function (child) {
      return {
        child: child,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [children]);

  var _useState = (0, _react.useState)(initialTabIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1]; // Wraps active tab in a ref to prevent re-rendering.
  // This means that we need to update the active tab before the index state change
  // to catch the re-render.


  var activeTab = (0, _react.useRef)(tabs[activeTabIndex]); // If the `initialTabIndex` changes; update the active one

  (0, _useUpdateEffect.useUpdateEffect)(function () {
    activeTab.current = tabs[initialTabIndex];
    setActiveTabIndex(initialTabIndex);
  }, [initialTabIndex, tabs]); // Ref of the tabs viewport

  var ref = (0, _react.useRef)(null); // Scroll to active tab when `activeTabIndex` changes

  (0, _react.useEffect)(function () {
    var _ref$current$scrollTo, _ref$current;

    if (!ref.current) return;
    var tab = activeTab.current.ref.current;
    if (!tab) return;
    var position = tab.offsetLeft;
    (_ref$current$scrollTo = (_ref$current = ref.current).scrollTo) === null || _ref$current$scrollTo === void 0 ? void 0 : _ref$current$scrollTo.call(_ref$current, {
      left: position,
      behavior: "smooth"
    });
  }, [activeTabIndex]);
  var handleClick = (0, _react.useCallback)(function (index) {
    return function () {
      var _tabs$index$child$pro;

      if (index === activeTabIndex) return;
      activeTab.current = tabs[index];
      setActiveTabIndex(index);
      if (!onChange) return;
      onChange({
        tabIndex: index,
        name: tabs[index].child.props.name,
        data: (_tabs$index$child$pro = tabs[index].child.props.data) !== null && _tabs$index$child$pro !== void 0 ? _tabs$index$child$pro : {}
      });
    };
  }, [activeTabIndex, onChange, tabs]);
  return {
    activeTab: activeTab,
    activeTabIndex: activeTabIndex,
    handleClick: handleClick,
    ref: ref,
    tabs: tabs
  };
};
/** A tab bar navigation component */


exports.useTabs = useTabs;

var Tabs = function Tabs(_ref2) {
  var children = _ref2.children,
      _ref2$initialTabIndex = _ref2.initialTabIndex,
      initialTabIndex = _ref2$initialTabIndex === void 0 ? 0 : _ref2$initialTabIndex,
      onChange = _ref2.onChange,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useTabs = useTabs({
    children: children,
    initialTabIndex: initialTabIndex,
    onChange: onChange
  }),
      tabs = _useTabs.tabs,
      activeTab = _useTabs.activeTab,
      activeTabIndex = _useTabs.activeTabIndex,
      handleClick = _useTabs.handleClick,
      ref = _useTabs.ref;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BaseTabs.BaseTabs, _extends({
    ref: ref
  }, rest), tabs.map(function (tab, i) {
    return /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, {
      key: i,
      ref: tab.ref,
      "aria-selected": i === activeTabIndex,
      onClick: handleClick(i),
      flex: 1
    }, /*#__PURE__*/_react.default.createElement(_BaseTabs.BaseTab, {
      active: i === activeTabIndex,
      variant: "sm"
    }, /*#__PURE__*/_react.default.createElement("span", null, tab.child.props.name)));
  })), activeTab.current.child);
};

exports.Tabs = Tabs;
Tabs.defaultProps = {
  mb: 2
};

/**
 * An individual tab.
 * Does nothing on its own; props are dealt with inside of Tabs.
 */
var Tab = function Tab(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};

exports.Tab = Tab;
//# sourceMappingURL=Tabs.js.map